import React from 'react';
import SelectCalendarMode from '../../../controllers/SelectCalendarMode';
import CalendarPagination from '../../../controllers/CalendarPagination';
import CalendarMonthTitle from '../../../controllers/CalendarMonthTitle';
import IntervalStatusBadges from '../IntervalStatusBadges';
import ToggleBoolSearchParam from '../../../../../controllers/ToogleBoolSearchParam';
import {
  searchParamKeys,
  calendarModeMap,
  searchParamSelectors,
  detailsPageModeMap,
} from '../../../../../shared/configs/searchParams';
import { useSearchParamsSelector } from '../../../../../shared/packages/searchParamsManager';
import { useHeaderRef } from '../services/headerSizeCalculator';
import styles from './index.module.scss';
import ExitRegistrationMode from '../../../controllers/ExitRegistrationMode';

const showTogglersModes = new Set([calendarModeMap.day, calendarModeMap.week]);

const Header = () => {
  const rootRef = useHeaderRef();

  return (
    <header className={styles.root} ref={rootRef}>
      <div className={styles.topRow}>
        <IntervalStatusBadges />
        <div className={styles.rightCol}>
          <Togglers />
          <div className={styles.wrapper}>
            <CalendarMonthTitle />
            <SelectCalendarMode />
            <CalendarPagination />
          </div>
        </div>
      </div>
      <ResetRegistrationsMode />
    </header>
  );
};

export default Header;

const registrationModes = [
  detailsPageModeMap.registration,
  detailsPageModeMap.reRegistration,
];
function ResetRegistrationsMode() {
  const pageMode = useSearchParamsSelector(
    searchParamSelectors[searchParamKeys.detailsPageMode]
  );

  if (!registrationModes.includes(pageMode)) {
    return null;
  }

  return (
    <ExitRegistrationMode pageMode={pageMode} className={styles.resetBtn} />
  );
}

function Togglers() {
  const mode = useSearchParamsSelector(
    searchParamSelectors[searchParamKeys.calendarMode]
  );

  if (showTogglersModes.has(mode)) {
    return (
      <div className={styles.wrapper}>
        <ToggleBoolSearchParam
          label="Собственник"
          searchParamKey={searchParamKeys.showClient}
        />
        <ToggleBoolSearchParam
          label="Адрес"
          searchParamKey={searchParamKeys.showAddress}
        />
      </div>
    );
  }

  return null;
}
